module.exports = __webpack_public_path__ + "img/face-no1.4eafcbe6.png";